export default "__VITE_ASSET__4fe579d8__"